export function numberFormatter(params: string[]) {
  const number = Number(params[0]);
  // Sweden locale uses space as thousands separator.
  const formattedNumber = number.toLocaleString('sv-SE');
  return formattedNumber;
}
